<template>
  <div class="td">
    <sc-text class="title" v-if="fields && fields.title" :field="fields.title" />
    <sc-text class="title-mobile" v-if="fields && fields.titleMobile" :field="fields.titleMobile" />
    <a v-if="fields" ref="tooltip" class="tooltip" :tooltipcolumn="`${tooltipContent}`">
      <span>Details</span>
    </a>

    <VueFinalModal
      v-model="fullwidthModal"
      class="final-modal fullwidthModal"
      content-class="final-modal-content"
      content-transition="vfm-fade"
      overlay-transition="vfm-fade"
    >
      <div class="c-modal">
        <div class="c-modal__content">
          <button class="c-modal__close" @click="fullwidthModal = false">X</button>
          <p>
            You will be linking to another website not owned or operated by CIS. CIS is not
            responsible for the availability or content of this website and does not represent
            either the linked website or you, should you enter into a transaction. The inclusion of
            any hyperlink does not imply any endorsement, investigation, verification or monitoring
            by CIS of any information in any hyperlinked site. We encourage you to review their
            privacy and security policies which may differ from CIS. If you "Proceed", the link will
            open in a new window.
          </p>
          <p class="proceed">
            <a
              v-if="link"
              :href="link"
              class="c-cta--secondary"
              target="_blank"
              rel="noopener noreferrer"
              @click="fullwidthModal = false"
            >
              Proceed
            </a>
          </p>
        </div>
      </div>
    </VueFinalModal>
  </div>
</template>

<script>
import { onMounted, ref, getCurrentInstance } from 'vue';
import { Text } from '@sitecore-jss/sitecore-jss-vue';
import tippy from 'tippy.js';
import { hideAll } from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import { VueFinalModal } from 'vue-final-modal';

export default {
  name: 'CIS-Hardened-Images-List-Column-Header',
  components: {
    ScText: Text,
    VueFinalModal
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    tooltipContent() {
      var tooltipContent = '';

      if (this.tooltipTitle) {
        tooltipContent += '<h5>' + this.tooltipTitle + '</h5>';
      }

      if (this.tooltipDescription) {
        tooltipContent += '<p>' + this.tooltipDescription + '</p>';
      }

      if (this.tooltipLink1Href && this.tooltipLink1Text) {
        tooltipContent +=
          '<p><a class="c-cta--secondary" href="' +
          this.tooltipLink1Href +
          '">' +
          this.tooltipLink1Text +
          '</a></p>';
      }

      if (this.tooltipLink2Href && this.tooltipLink2Text) {
        tooltipContent +=
          '<a class="external-link" target="_blank" rel="noopener noreferrer" href="' +
          this.tooltipLink2Href +
          '">' +
          this.tooltipLink2Text +
          '</a>';
      }

      return tooltipContent;
    },
    tooltipTitle() {
      return this?.fields?.tooltipTitle?.value;
    },
    tooltipDescription() {
      return this?.fields?.tooltipDescription?.value;
    },
    tooltipLink1Href() {
      return this?.fields?.tooltipLink1?.value?.href;
    },
    tooltipLink1Text() {
      return this?.fields?.tooltipLink1?.value?.text;
    },
    tooltipLink2Href() {
      return this?.fields?.tooltipLink2?.value?.href;
    },
    tooltipLink2Text() {
      return this?.fields?.tooltipLink2?.value?.text;
    }
  },
  setup() {
    const fullwidthModal = ref(false);
    const tooltip = ref();
    const link = ref();

    onMounted(() => {
      tippy(tooltip.value, {
        content: (reference) =>
          reference.getAttribute('tooltipcolumn') + '<div class="tooltip-close">X</div>',
        allowHTML: true,
        interactive: true,
        interactiveDebounce: 75,
        maxWidth: 400,
        placement: 'top-end',
        touch: true,
        onCreate(instance) {
          instance.popper.querySelector('.tooltip-close').onclick = () => {
            instance.hide();
          };
        },
        onMount(instance) {
          const externalLink = instance.popper.querySelector('.external-link');

          if (externalLink) {
            if (
              externalLink.href?.indexOf('http://') == 0 ||
              externalLink.href?.indexOf('https://') == 0
            ) {
              externalLink.addEventListener('click', function (event) {
                event.preventDefault();
                link.value = event.target.href;
                fullwidthModal.value = true;
              });
            }
          }
        },
        onShow() {
          hideAll();
        }
      });
    });

    return {
      tooltip,
      link,
      fullwidthModal
    };
  }
};
</script>
<style lang="scss" scoped>
.td {
  .title {
    display: none;

    @include desktop-up {
      display: block;
      @include font-styles('Arial', 2.3rem, 200, normal, 3rem, 0, $dark-blue);
      margin-bottom: 0.5rem;
    }
  }

  .title-mobile {
    display: none;

    @include desktop-down {
      display: block;
      @include font-styles('Arial', 1.6rem, 500, normal, 2rem, 0, $dark-blue);
    }
  }

  .tooltip {
    @include font-styles('Arial Narrow', 1.4rem, 600, normal, 1.7rem, 0, $dark-blue);
    text-transform: uppercase;
    padding-right: 2.1rem;

    &:after {
      transform: translateY(0);
    }

    span {
      display: none;
      @include desktop-up {
        display: block;
      }
    }
  }

  &:deep() {
    .tippy-box {
      padding: 2rem;
      left: 1rem;

      @include desktop-up {
        padding: 2.4rem;
      }

      .tippy-content {
        text-align: left;

        h5 {
          @include font-styles('Arial', 2rem, 500, normal, 2.6rem, 0, $white);
          margin: 0 0 0.8rem 0;
        }

        p {
          font-weight: 100;
          margin: 0 0 1.6rem 0;
        }

        .c-cta--secondary {
          margin-bottom: 0;
          border-left: 0.4rem solid $white;
          font-weight: 400;

          &:hover {
            color: $white;
          }

          &:after {
            background-image: url(~@/assets/images/icon-arrow-right-white-mobile.svg);
            background-repeat: no-repeat;
            background-size: contain;
            width: 1.7rem;
            min-width: 1.7rem;
            height: 1.3rem;
            min-height: 1.3rem;
          }
        }

        .external-link {
          font-weight: 400;

          &:after {
            content: '';
            background: url(~@/assets/images/icon-external-link-white.svg) no-repeat;
            margin-left: 1rem;
          }
        }
      }
    }

    .tippy-box[data-placement^='top-start'],
    .tippy-box[data-placement^='top-end'] {
      top: -1.7rem;

      @include desktop-up {
        top: -0.7rem;
      }
    }

    .tippy-box[data-placement^='bottom-start'],
    .tippy-box[data-placement^='bottom-end'] {
      bottom: -0.7rem;
    }

    .tippy-box[data-placement^='top-end'] > .tippy-arrow,
    .tippy-box[data-placement^='bottom-end'] > .tippy-arrow {
      @include desktop-up {
        right: -1.3rem !important;
      }
    }

    .tippy-box[data-placement^='top'] > .tippy-arrow::before,
    .tippy-box[data-placement^='bottom'] > .tippy-arrow::before {
      left: -0.4rem;

      @include desktop-up {
        left: 0;
      }
    }
  }
}
</style>
